import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function CountdownTimer() {
  // Set initial time to 30 minutes
  const [timeLeft, setTimeLeft] = useState(30 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  // Progress bar: percentage of time elapsed (starts full, drains to 0)
  const totalTime = 30 * 60;
  const progressPercent = Math.round((1 - timeLeft / totalTime) * 100);
  return <div className="py-16 px-4 text-center" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-lg mx-auto" data-id="element-78">
        {/* Header */}
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 uppercase tracking-wide" data-id="element-79">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h3>

        {/* Countdown Numbers */}
        <div className="flex justify-center items-baseline gap-1 md:gap-2 mb-8" data-id="element-80">
          <div className="text-center" data-id="element-81">
            <span className="text-6xl md:text-8xl font-bold text-red-500 font-mono tabular-nums" data-id="element-82">
              {formatTime(hours)}
            </span>
            <span className="block text-sm md:text-base text-gray-400 uppercase mt-2 font-sans tracking-widest" data-id="element-83">
              HS
            </span>
          </div>
          <span className="text-5xl md:text-7xl font-bold text-red-500 font-mono pb-6" data-id="element-84">
            :
          </span>
          <div className="text-center" data-id="element-85">
            <span className="text-6xl md:text-8xl font-bold text-red-500 font-mono tabular-nums" data-id="element-86">
              {formatTime(minutes)}
            </span>
            <span className="block text-sm md:text-base text-gray-400 uppercase mt-2 font-sans tracking-widest" data-id="element-87">
              MIN
            </span>
          </div>
          <span className="text-5xl md:text-7xl font-bold text-red-500 font-mono pb-6" data-id="element-88">
            :
          </span>
          <div className="text-center" data-id="element-89">
            <span className="text-6xl md:text-8xl font-bold text-red-500 font-mono tabular-nums" data-id="element-90">
              {formatTime(seconds)}
            </span>
            <span className="block text-sm md:text-base text-gray-400 uppercase mt-2 font-sans tracking-widest" data-id="element-91">
              SEG
            </span>
          </div>
        </div>

        {/* Warning text */}
        <div className="flex items-center justify-center gap-2 mb-10" data-id="element-92">
          <AlertTriangle className="w-6 h-6 text-yellow-400" data-id="element-93" />
          <p className="text-lg md:text-xl text-white font-medium" data-id="element-94">
            Después sube{' '}
            <span className="text-red-500 font-bold" data-id="element-95">$10.000 ARS</span>. No
            vuelve.
          </p>
        </div>

        {/* Cupos progress bar */}
        <div className="max-w-md mx-auto" data-id="element-96">
          <div className="flex justify-between items-center mb-2" data-id="element-97">
            <span className="text-red-400 font-semibold flex items-center gap-2" data-id="element-98">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-white font-bold text-sm" data-id="element-99">Quedan pocos</span>
          </div>
          <div className="w-full h-3 bg-gray-700 rounded-full overflow-hidden" data-id="element-100">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: `${Math.min(72 + progressPercent * 0.2, 95)}%`
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full rounded-full bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500" data-id="element-101" />
          </div>
          <p className="text-gray-400 text-sm mt-2" data-id="element-102">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </motion.div>
    </div>;
}